import { call, put, takeEvery } from "redux-saga/effects";
import toastr from "toastr";

import {
  GET_ALERTS,
  GET_AWS_MISSING_ALERTS_BY_RESOURCE_ID,
  GET_AWS_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  GET_AWS_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID,
  DEPLOY_AWS_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  GET_AWS_RESOURCE_BY_RESOURCE_ID,
  GET_DEFAULT_THRESHOLD_BY_RESOURCE_ID,
  GET_NR_MISSING_ALERTS_BY_RESOURCE_ID,
  POST_DISABLE_ALERTS,
  POST_ENABLE_ALERTS,
  POST_SERVICE_MAPPING,
  PUT_ALERTS,
} from "./actionTypes";

import {
  getAlertsFail,
  getAlertsSuccess,
  getAWSResourceByResourceIDFail,
  getAWSResourceByResourceIDSuccess,
  getDefaultThresholdByMonitoredResourceIDFail,
  getDefaultThresholdByMonitoredResourceIDSuccess,
  getMissingAWSAlertsByResourceIDFail,
  getMissingAWSAlertsByResourceIDSuccess,
  getMissingAWSDynamicAlertsByResourceIDFail,
  getMissingAWSDynamicAlertsByResourceIDSuccess,
  getAWSDynamicAlertsDeployedByResourceIDFail,
  getAWSDynamicAlertsDeployedByResourceIDSuccess,
  deployAWSDynamicAlertsByResourceIDFail,
  deployAWSDynamicAlertsByResourceIDSuccess,
  getMissingNRAlertsByResourceIDFail,
  getMissingNRAlertsByResourceIDSuccess,
  postDisableAlertsSuccess,
  postEnableAlertsFail,
  postEnableAlertsSuccess,
  postServiceMappingFail,
  postServiceMappingSuccess,
  putAlertsFail,
  putAlertsSuccess
} from "./actions";

import {
  getAlertsUrl,
  getAWSMissingAlertsByResourceIDUrl,
  getAWSMissingDynamicAlertsByResourceIdUrl,
  getAWSDynamicAlertsDeployedByResourceIdUrl,
  deployAWSDynamicAlertsByResourceIdUrl,
  getAWSResourceByIDUrl,
  getDefaultThresholdByMonitoredResourceIDUrl,
  getNRMissingAlertsByResourceIDUrl,
  postDisableAlertUrl,
  postEnableAlertUrl,
  postServiceMapping,
  putUpdateAlertUrl,
} from "../../helpers/fakebackend_helper";

function* onGetAWSMissingAlertsByResourceID(resource_id) {
  try {
    const response = yield call(getAWSMissingAlertsByResourceIDUrl, resource_id.payload);
    yield put(getMissingAWSAlertsByResourceIDSuccess(response));
  } catch (error) {
    yield put(getMissingAWSAlertsByResourceIDFail(error.message));
  }
}

function* onGetDefaultThresholdMissingAlertsByResourceID(resource_id) {
  try {
    const response = yield call(getDefaultThresholdByMonitoredResourceIDUrl, resource_id.payload);
    yield put(getDefaultThresholdByMonitoredResourceIDSuccess(response));
  } catch (error) {
    yield put(getDefaultThresholdByMonitoredResourceIDFail(error.message));
  }
}

function* onGetAWSResourceByID(resource_id) {
  try {
    const response = yield call(getAWSResourceByIDUrl, resource_id.payload);
    yield put(getAWSResourceByResourceIDSuccess(response));
  } catch (error) {
    yield put(getAWSResourceByResourceIDFail(error.message));
  }
}

function* onGetNRMissingAlertsByResourceID(monitored_resource_id) {
  try {
    const response = yield call(getNRMissingAlertsByResourceIDUrl, monitored_resource_id.payload);
    yield put(getMissingNRAlertsByResourceIDSuccess(response));
  } catch (error) {
    yield put(getMissingNRAlertsByResourceIDFail(error.message));
  }
}


function* onPostServiceMapping({ payload: { service_mapping } }) {
  try {
    const response = yield call(postServiceMapping, service_mapping);
    yield put(postServiceMappingSuccess(response));
    window.location.reload();
  } catch (error) {
    yield put(postServiceMappingFail(error.message));
  }
}

function* onPutUpdateAlerts({ payload: { alerts } }) {
  try {
    const response = yield call(putUpdateAlertUrl, alerts);
    yield put(putAlertsSuccess(response));
    window.location.reload();
  } catch (error) {
    yield put(putAlertsFail(error.message));
  }
}

function* onGetAlerts(monitored_resource_id) {
  try {
    const response = yield call(getAlertsUrl, monitored_resource_id.payload);
    let final_response = {}
    final_response[monitored_resource_id.payload] = response;
    yield put(getAlertsSuccess(final_response));
  } catch (error) {
    yield put(getAlertsFail(error));
  }
}

function* onPostDisableAlerts({ payload: { alerts } }) {
  try {
    const response = yield call(postDisableAlertUrl, alerts);
    yield put(postDisableAlertsSuccess(response));
    window.location.reload();
  } catch (error) {
    yield put(postDisableAlertsFail(error));
  }
}

function* onPostEnableAlerts({ payload: { alerts } }) {
  try {
    const response = yield call(postEnableAlertUrl, alerts)
    yield put(postEnableAlertsSuccess(response));
    window.location.reload();
  } catch (error) {
    yield put(postEnableAlertsFail(error));
  }
}

function* onGetAWSMissingDynamicAlertsByResourceID(resource_id) {
  try {
    const response = yield call(getAWSMissingDynamicAlertsByResourceIdUrl, { monitored_resource_id: resource_id.payload });
    yield put(getMissingAWSDynamicAlertsByResourceIDSuccess(response));
  } catch (error) {
    yield put(getMissingAWSDynamicAlertsByResourceIDFail(error.message));
  }
}

function* onGetAWSDynamicAlertsDeployedByResourceID(resource_id) {
  try {
    const response = yield call(getAWSDynamicAlertsDeployedByResourceIdUrl, { monitored_resource_id: resource_id.payload });
    yield put(getAWSDynamicAlertsDeployedByResourceIDSuccess(response));
  } catch (error) {
    yield put(getAWSDynamicAlertsDeployedByResourceIDFail(error.message));
  }
}

function* onDeployAWSDynamicAlertsByResourceID(data) {
  try {
    const response = yield call(deployAWSDynamicAlertsByResourceIdUrl, data.payload);
    yield put(deployAWSDynamicAlertsByResourceIDSuccess(response));

    toastr.success("Dynamic alerts deployed successfully");
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  } catch (error) {
    yield put(deployAWSDynamicAlertsByResourceIDFail(error));
    toastr.error("Dynamic alerts deployment failed");
  }
}

function* alertSaga() {
  yield takeEvery(GET_AWS_MISSING_ALERTS_BY_RESOURCE_ID, onGetAWSMissingAlertsByResourceID);
  yield takeEvery(GET_NR_MISSING_ALERTS_BY_RESOURCE_ID, onGetNRMissingAlertsByResourceID);
  yield takeEvery(GET_AWS_RESOURCE_BY_RESOURCE_ID, onGetAWSResourceByID);
  yield takeEvery(GET_DEFAULT_THRESHOLD_BY_RESOURCE_ID, onGetDefaultThresholdMissingAlertsByResourceID);
  yield takeEvery(POST_SERVICE_MAPPING, onPostServiceMapping);
  yield takeEvery(PUT_ALERTS, onPutUpdateAlerts);
  yield takeEvery(GET_ALERTS, onGetAlerts);
  yield takeEvery(POST_DISABLE_ALERTS, onPostDisableAlerts);
  yield takeEvery(POST_ENABLE_ALERTS, onPostEnableAlerts);
  yield takeEvery(GET_AWS_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID, onGetAWSMissingDynamicAlertsByResourceID);
  yield takeEvery(GET_AWS_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID, onGetAWSDynamicAlertsDeployedByResourceID);
  yield takeEvery(DEPLOY_AWS_DYNAMIC_ALERTS_BY_RESOURCE_ID, onDeployAWSDynamicAlertsByResourceID);
}

export default alertSaga;
